import { useEffect, useState } from "react";
import { getImageSmallUrl } from "../../helper/getImageUrl";
import { Button } from "reactstrap";
import { getThumbnailUrl } from "../../helper/getThumbnailUrl";


export default function ToggleableImage({ image, fromVideo = false }: { image: string, fromVideo? : boolean }) {
    const [showImage, setShowImage] = useState(false);
    const [showAsLink, setShowAsLink] = useState(false);
    const [imageToShow, setImageToShow] = useState("");

    useEffect(() => {
        if(fromVideo) {
            if(image.includes("http")) {
               setImageToShow(image ? getThumbnailUrl(image) : ""); 
            }
            else {
                setShowAsLink(true);
            }
        }
        else {
            setImageToShow(image ? getImageSmallUrl(image) : "");
        }
    },[fromVideo, image]);

    

    return (
        <>
            {showImage ? (
                <div>
                    {
                        showAsLink === false ?
                        <img
                            style={{
                                borderRadius: "0.375rem",
                                marginBottom: "1rem",
                                height: "100px",
                            }}
                            src={imageToShow}
                            alt="error"
                            onClick={() => {
                                //open the video in a new tab
                                window.open(image, "_blank");
                            }}
                            role="button"
                        />
                        :
                        <a href={image} target="_blank" rel="noopener noreferrer">Link To Video</a>

                    }
                    <div>
                    <Button size="sm" color="secondary" className="pt-2" onClick={() => setShowImage(false)}>
                        Hide
                    </Button>
                    </div>
                </div>
            ) : (
                <Button size="sm" color="secondary" onClick={() => setShowImage(true)}>
                    Show {fromVideo ? "Video" : "Image"}
                </Button>
            )}
        </>
    );
};